import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import { useParams, useHistory } from 'react-router-dom'
import { getPaymentCheck } from '../../../redux/actions/paymentCheck'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import { Col, Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import ApproverDetailWidgets from '../../../widgets/ApproverDetail/ApproverDetailWidgets'
import ProposeConsiderApproveProjectWidget from '../../../widgets/proposeConsiderApproveProject/ProposeConsiderApproveProjectWidget'
import {
  downloadRequestApproveFile,
  getProposeConsiderApproveProject,
} from '../../../redux/actions/proposeConsiderApproveProject'
import ProposeConsiderApproveProjectMultiWidget from '../../../widgets/proposeConsiderApproveProject/ProposeConsiderApproveProjectMultiWidget'
import {
  GetMultiProjectConsiderApprovePage,
  GetMultiProjectConsiderApproveProjectList,
} from '../../../redux/actions/multiReview'

export default function ProposeConsiderApproveProjectMulti() {
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [confirmForceSchema, setConfirmForceSchema] = useState()

  // const [isLoading, setIsLoading] = useState(false)
  const [isReLoading, setIsReLoading] = useState(false)
  // const [error, setError] = useState()
  // const [schema, setSchema] = useState()
  const [proposal, setProposal] = useState()
  const [section, setSection] = useState()
  const [dataTableSection, setDataTableSection] = useState()
  const [singleProject, setSingleProject] = useState()
  const [singleError, setSingleError] = useState()
  const [projectList, setProjectList] = useState()
  // const [isEditBudgetPlan, setIsEditBudgetPlan] = useState(false)

  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [enableForm, setEnableForm] = useState(false)
  const [budgetschema, setBudgetSchema] = useState()

  // const proposalId = '1D3684B7-4D9D-4DED-AE29-DEC6C214B8EC'

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()
    try {
      setProposal('')
      setSingleProject('')
      const _schema = await GetMultiProjectConsiderApprovePage(projectId)
      // console.log('handleGetSchema response', _schema)
      // const _schema = mock
      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      setProposal('')
      setSingleProject('')
      const response = await GetMultiProjectConsiderApproveProjectList(
        projectId,
        pagesize,
        pagenumber
      )
      setProjectList(response)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const onSingleSubmit = async (obj) => {
    console.log('obj', obj)
    setSingleError(false)
    startLoading()
    try {
      setProposal('')
      setSingleProject(obj)
      const responseApprove = await getProposeConsiderApproveProject(obj.id)

      const responsePayment = await getPaymentCheck(obj.id)
      // const response = singleMock
      // console.log('responseApprove', responseApprove)
      // console.log('responsePayment', responsePayment)

      let _schema = responseApprove
      let _schemaPayment = responsePayment

      if (_schema) {
        _schema['header'] = obj.projectName
        setProposal(_schema)
        setBudgetSchema(_schemaPayment)
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      }

      console.log('_schema', _schema)
    } catch (e) {
      console.log('e', e)
      setSingleError(true)
    }

    doneLoading()
  }

  const handleGetFile = async (id) => {
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await downloadRequestApproveFile(id)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      setIsPdfError(true)
    }
    setIsLoadingPDF(false)
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      {/* บล็อกหลายโครงการ */}

      <Row
        ref={(section) => {
          setDataTableSection(section)
        }}
      ></Row>

      {schema?.forms?.projectApprove && (
        <ProposeConsiderApproveProjectMultiWidget
          showCommandButton={!schema?.forms?.disabled || enableForm}
          schema={schema?.forms?.projectApprove}
          // disabled={isInvalidAttorneyPerson}
          disabled={
            schema?.forms?.projectApprove?.contractSignType.value &&
            schema?.forms?.projectApprove?.inputNoteToReport.value &&
            schema?.forms?.projectApprove?.inputNote.value
          }
          onEnableForm={() => setEnableForm(!enableForm)}
          isConfirmEbudget={schema?.forms?.projectApprove?.isConfirmBudget}
          onComplete={(data) => {
            //console.log('data=', data)
            setSchema(data)
            setProjectList(data?.forms?.projectList)
          }}
        />
      )}

      {/* {schema.forms?.approverDetail?.approverList?.length > 0 && (
        <>
          <ApproverDetailWidgets schema={schema.forms?.approverDetail} />

          <br />
        </>
      )} */}

      {projectList && (
        <>
          <ProjectDataTable
            schema={projectList}
            // single={{
            //   enable: true,
            //   buttonText: projectList.buttonText || 'เสนอพิจราณาอนุมัติ',
            //   iconByStatus: true,
            //   hideText: false,
            //   width: 210,
            // }}
            // onSingleSubmit={onSingleSubmit}
            pagination={true}
            onReload={handleReload}
            loading={isReLoading}
          />
          <br />
        </>
      )}

      <Row
        ref={(section) => {
          setSection(section)
        }}
      >
        {singleError && (
          <>
            <Message
              showIcon
              type="error"
              description={`ดึงข้อมูลโครงการ ${singleProject?.projectName} ไม่สำเร็จ`}
            />
            <br />
          </>
        )}
      </Row>

      {proposal && (
        <>
          <Panel
            header={
              <div>
                <Col xs={20} sm={20} md={20} lg={20}>
                  {proposal.header}
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} align="right">
                  <CancelButton
                    onClick={() => {
                      setProposal('')
                    }}
                  >{`ปิด`}</CancelButton>
                </Col>
              </div>
            }
            bordered
            collapsible
            defaultExpanded
            shaded
            style={{ marginBottom: 20 }}
          >
            <ProjectBasicInfo schema={proposal?.projectInfo} shaded={false} />

            <br />

            <ProposeConsiderApproveProjectWidget
              showCommandButton={!proposal?.forms?.disabled || enableForm}
              schema={proposal.forms}
              // disabled={isInvalidAttorneyPerson}
              disabled={true}
              onEnableForm={() => setEnableForm(!enableForm)}
              isConfirmEbudget={
                budgetschema?.forms?.budget?.isDisabled &&
                budgetschema?.forms?.budgetInstallmentPlan?.installment?.length > 0
                  ? true
                  : false
              }
            />
            <br />

            {schema.forms?.approverDetail?.approverList?.length > 0 && (
              <>
                <ApproverDetailWidgets
                  dataList={schema.forms?.approverDetail?.approverList}
                  header={schema.forms?.approverDetail?.title}
                />

                <br />
              </>
            )}

            {isPdfError ? (
              <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
            ) : (
              <PdfRenderWidgets
                header={'แบบขออนุมัติและจัดทำสัญญา'}
                file={previewPdf}
                isLoading={isLoadingPDF}
                fileName={'แบบขออนุมัติและจัดทำสัญญา'}
                onReload={() => {
                  handleGetFile(projectId)
                }}
                loadingMessage={'กรุณารอสักครู่ ระบบกำลังสร้าง PDF แบบขออนุมัติและจัดทำสัญญา...'}
                firstExpandToReload={true}
              />
            )}
            <br />
          </Panel>
        </>
      )}
    </SidebarProposal>
  )
}
